import React, { useState } from "react";
import { Grid, Paper, makeStyles } from "@material-ui/core";
import { NoPhysicalRoomsData, ConfirmPhysicalRoomDialog } from ".";

const useStyles = makeStyles(() => ({
  paperContainer: {
    marginTop: "32px"
  },
  contentPaper: {
    padding: "32px",
    margin: "8px",
    textAlign: "center",
    cursor: "pointer"
  }
}));

const PhysicalRoomsGrid = ({ rooms }) => {
  const classes = useStyles();
  const [selectedRoom, setSelectedRoom] = useState(null);

  const handleOpenDialog = room => {
    setSelectedRoom(room);
  };

  const handleCloseDialog = () => {
    setSelectedRoom(null);
  };

  return (
    <NoPhysicalRoomsData data={rooms}>
      <Grid container spacing={2} className={classes.paperContainer}>
        {(rooms || []).map(room => (
          <Grid item xs={12} sm={6} md={4} key={room.id}>
            <Paper
              elevation={3}
              className={classes.contentPaper}
              onClick={() => handleOpenDialog(room)}
            >
              {room.name}
            </Paper>
          </Grid>
        ))}
      </Grid>
      {selectedRoom && (
        <ConfirmPhysicalRoomDialog
          selectedRoom={selectedRoom}
          handleCloseDialog={handleCloseDialog}
        />
      )}
    </NoPhysicalRoomsData>
  );
};

export default PhysicalRoomsGrid;
